export const iconFontAwesomeHouseholdToilet = (
	<i className="fa-solid fa-toilet"></i>
);
